export default __webpack_public_path__ + "static/bumpa-analytics-4045ba47eeccf5c511a3d8d76d16a296.mp4";